<template>
  <b-row>
    <b-col cols="3">
      <label class="sa-label-data">Listino</label>
      <b-input-group class="mt-3">
        <b-form-input v-model="jsonData.listino" :disabled="!isEdit"></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-info"><font-awesome-icon icon="search" /></b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>
    <b-col cols="4">
      <label class="sa-label-data">Lista Impegnative</label>
      <b-form-select v-model="impegnativa" :options="impegnative" value-field="id" text-field="nome">
        <template #first>
          <b-form-select-option disabled :value="null">Seleziona</b-form-select-option>
        </template>
      </b-form-select>
    </b-col>
    <b-col cols="4">
      <label class="sa-label-data">Prestazione</label>
      <b-input-group class="mt-3">
        <b-form-input v-model="jsonData.prestazione" :disabled="!isEdit"></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-info"><font-awesome-icon icon="search" /></b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>

    <b-col cols="12">
      <div class="sa-flexbox" style="padding-bottom: 20px">
        <div class="sa-flexbox-body">
          <div class="d-flex flex-column">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
              <b-col lg="3">
                <p>Records Totali: {{ rowsDettaglio }}</p>
              </b-col>
              <b-col lg="9">
                <b-pagination :total-rows="rowsDettaglio" v-model="page" :per-page="perPage" align="right" size="sm">
                </b-pagination>
              </b-col>
            </b-row>
          </div>
          <div class="b-table-sticky-header">
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="arrayPrestazioni"
              :fields="fieldsDettaglio" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left
              head-variant="light" class="sa-b-table">
              <template #cell(index)="row">
                {{ (page - 1) * perPage + row.index + 1 }}
              </template>
              <template #cell(quantita)="row">
                <b-form-input type="number" v-model="row.item.quantita"></b-form-input>
              </template>
              <template #cell(prezzo)="row">
                <b-form-input type="number" disabled v-model="row.item.prezzo"></b-form-input>
              </template>
              <template #cell(codSogei)="row">
                <b-form-input type="text" disabled v-model="row.item.codSogei"></b-form-input>
              </template>
              <template #cell(dataErogazione)="row">
                <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="row.item.dataErogazione"
                  type="date"></date-picker>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    impegnative: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tipologia: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  components: { DatePicker },
  data() {
    return {
      search: false,
      itemsDettaglio: [],
      page: 1,
      arrayPrestazioni: [],
      perPage: 10,
      filtro: {},
      listKey: 0,
      impegnativa: null,
      jsonData: {
        listaDettagli: [],
      },
      fieldsDettaglio: [
        {
          label: "N.",
          key: "index",
        },
        {
          label: "Quantita",
          key: "quantita",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
        {
          label: "Prestazione",
          key: "nome",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
        {
          label: "Prezzo",
          key: "prezzo",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
        {
          label: "Importo",
          key: "importo",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
        {
          label: "Codice Sogei",
          key: "codSogei",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
        {
          label: "Data Erogazione",
          key: "dataErogazione",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
        {
          label: "",
          key: "actions",
          //   sortable: true,
          //   thStyle: "width: 18rem",
        },
      ],
    };
  },
  mixins: { UtilityMixin },
  mounted() {
    let me = this;
    me.init();
  },
  computed: {
    rowsDettaglio() {
      //let me = this;
      return 0;
    },
    isDematerializzata() {
      let me = this;

      return me.tipologia == "DEMATERIALIZZATA";
    },
  },

  methods: {
    init() {
      let me = this;
      me.$emit("beforeLoadData");
    },
  },
  watch: {
    impegnativa: {
      deep: true,
      immediate: true,
      handler(value) {
        console.log(value);
      }
    }
  },
};
</script>
<style></style>
